import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Error from "views/error";
import Home from "views/home";
import Login from "views/login";
import { PrivateRoute } from "auth/privateRoute";
import Register from "views/register";
import TKTMockPage from "views/tktMockPage";
import { OptionProvider } from "utils/optionsContext";
import { pdfjs, Document, Page } from "react-pdf";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import en from "locales/en";
import uz from "locales/uz";
import ru from "locales/ru";
import ChangePassword from "views/changePassword";
import ForgotPassword from "views/forgotPassword";
import ResetPassword from "views/resetPassword";

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: en,
      },
      uz: {
        translation: uz,
      },
      ru: {
        translation: ru,
      },
    },
    lng: "uz", // if you're using a language detector, do not define the lng option
    fallbackLng: "uz",

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  });

function App() {
  return (
    <OptionProvider>
      <div className="App">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <Router>
          <Routes>
            <Route path="/" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="forgot-password" element={<ForgotPassword />} />
            <Route path="reset-password/:token" element={<ResetPassword />} />
            <Route
              path="/change-password"
              element={
                <PrivateRoute>
                  <ChangePassword />
                </PrivateRoute>
              }
            />
            <Route
              path="/home"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/mock/:id"
              element={
                <PrivateRoute>
                  <TKTMockPage />
                </PrivateRoute>
              }
            />
            <Route path="/error" element={<Error />} />{" "}
            <Route path="*" element={<Error />} />
          </Routes>
        </Router>
      </div>
    </OptionProvider>
  );
}

export default App;
